<template>
	<div class="container mt-4">
	    <div class="row">
	        <div class="col-md-12">
	            <div class="error-template box-shadow whiteBG border-radius p-3 text-center">
	            	<!-- <img src="../../../../static/website/images/sessionExpire.svg" alt="Icon"> -->
	                <h1>Oops!</h1>
	                <h2>404 Not Found</h2>
	                <div class="error-details mb-4">
	                    Sorry, an error has occured, Requested page not found!
	                </div>
	                <div class="error-actions mb-4">
	                    <router-link class="cap_btn large" to="/get-started">Back to Home</router-link>
	                </div>
	            </div>
	        </div>
	    </div>
	</div>
</template>
<script>  
export default {
    name: 'Page not Found',
    data () {
        return {
          
        }
      },
   
}
</script>


// WEBPACK FOOTER //
// src/components/website/shared/page-not-found.vue